// @flow

import { connect } from 'react-redux';

import { fetchSeason } from 'actions/seasonsActions';
import TeamFilter, { type DispatchProps, type StateProps } from 'components/team/TeamFilter';
import { selectCompetitionLink } from 'selectors/selectSettings';
import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  competitionsEquipes: state.settingsState.competitionsEquipes,
  competitionsOvale: state.pageListState.competitions,
  competitionLink: selectCompetitionLink(state),
  currentSeason: state.seasonsState.lastSeason,
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchSeasons: () => dispatch(fetchSeason()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamFilter);
